import React from 'react'
import { Button, Spinner } from 'react-bootstrap'
import hooks from '../../../hooks'
import useAvailableLink from './use-available-link'

const Center = ({ children }) => (<div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'center', alignItems: 'center' }}>{children}</div>)

const IOSScreen = () => {
    const { windowLocation } = hooks.useClientLocation()

    const { url, isLoading } = useAvailableLink()

    const onClick = React.useCallback(() => {
        console.log('url:', url)
        windowLocation(url, true)
    }, [windowLocation, url])

    if (isLoading) {
        return (
            <Center>
                <Spinner animation="border" variant="primary" />
            </Center>
        )
    }

    if (!url) {
        return (
            <Center>
                This app isn't available at this time.  Please check back later.
            </Center>
        )
    }

    return (
        <Center>
            <Button
                onClick={onClick}
            >
                Click here to install Android app
            </Button>

        </Center>
    )
}

export default IOSScreen
